import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

export default function PickStatus({
  pickedStatus,
  advancedPickingMode = false,
  isKit = false,
  loading = false,
  scanOutModal = false,
  orderType = "inventoryRequest",
  onPickKit,
  onScanOut,
  onMarkAsPicked,
}) {
  const isInternalWorkOrder = orderType === "internalWorkOrder";
  const completeLabel = isInternalWorkOrder ? "Staged" : "Picking Complete";
  const notPickedLabel = isInternalWorkOrder ? "Pending Staging" : "Not Picked";

  if (pickedStatus) {
    return (
      <Box
        display="inline-block"
        bgcolor="#D5F5D5"
        px={1}
        py={0.5}
        borderRadius={1}
        textAlign="center"
      >
        <Typography fontWeight="500">{completeLabel}</Typography>
      </Box>
    );
  }

  if (!advancedPickingMode || isInternalWorkOrder) {
    return (
      <Box
        display="inline-block"
        bgcolor="#F8D7DA"
        px={1}
        py={0.5}
        borderRadius={1}
        textAlign="center"
      >
        <Typography fontWeight="500">{notPickedLabel}</Typography>
      </Box>
    );
  }

  if (isKit) {
    return (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={onPickKit}
        startIcon={loading && <CircularProgress size={16} />}
        disabled={loading}
      >
        Pick Kit
      </Button>
    );
  }

  if (scanOutModal) {
    return (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={onScanOut}
        startIcon={loading && <CircularProgress size={16} />}
        disabled={loading}
      >
        Scan Out
      </Button>
    );
  }

  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={onMarkAsPicked}
      startIcon={loading && <CircularProgress size={16} />}
      disabled={loading}
    >
      Mark as Picked
    </Button>
  );
} 